export default __webpack_public_path__ + "static/partner13-cafdb2d6ff759428f7d98e178c33389f.png";